const rootPaths = {
  thinkCaddie: 'https://thinkcaddie.com'
};

const links = {
  thinkCaddie: {
    root: rootPaths.thinkCaddie,
    home: `${rootPaths.thinkCaddie}/`,
    about: `${rootPaths.thinkCaddie}/about-us/`,
    contact: `${rootPaths.thinkCaddie}/contact/`,
    terms: `${rootPaths.thinkCaddie}/terms-of-use/`,
    pricing: `${rootPaths.thinkCaddie}/pricing/`,
    privacy: `${rootPaths.thinkCaddie}/privacy-policy/`,
    blog: `${rootPaths.thinkCaddie}/posts`,
    support: 'https://thinkcaddie.freshdesk.com/support/home'
  }
}

export default links;



// WEBPACK FOOTER //
// ./src/constants/links.js